import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import {
  Field,
  arrayRemove,
  change
} from 'redux-form';
import { connect } from 'react-redux';

import { resolveObjPath } from 'components/Common/Inputs/NestedArrayObjectField';

class NestedArraySelectFieldInput extends Component {
  static propTypes = {
    input: PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.any
    }).isRequired,
    meta: PropTypes.shape({
      dispatch: PropTypes.func,
      form: PropTypes.string
    }).isRequired,
    placeholder: PropTypes.string,
    className: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types
    initValue: PropTypes.any,
    // eslint-disable-next-line react/forbid-prop-types
    children: PropTypes.any
  };

  static defaultProps = {
    placeholder: '',
    className: '',
    initValue: undefined,
    children: undefined
  };

  componentDidMount() {
    const {
      input: { name, value },
      meta: { dispatch, form },
      initValue
    } = this.props;
    if ((value === null || value === undefined || value === '') && initValue !== undefined) {
      dispatch(change(form, name, initValue));
    }
  }

  render() {
    const {
      input,
      placeholder,
      className,
      children
    } = this.props;
    return (
      <div>
        <select
          { ...input }
          placeholder={ placeholder }
          className={ className }
        >
          { children }
        </select>
      </div>
    );
  }
}

const NestedArraySelectFieldComponent = ({
  dispatch,
  name,
  rootField,
  formName,
  initValue,
  children
}) => (
  <Field
    name={ name }
    component={ NestedArraySelectFieldInput }
    className="form-select"
    rootField={ rootField }
    initValue={ initValue }
    onBlur={ (event, newVal, prevVal) => {
      if (!prevVal && !newVal) {
        event.preventDefault();
      }
    } }
    normalize={ (value, prevVal, allValues, prevAllValues) => {
      const rootFieldValue = resolveObjPath(rootField, allValues);
      if (rootFieldValue) {
        const itemIndex = name.replace(/(^.*\[|\].*$)/g, '');
        const rootFieldItem = rootFieldValue[itemIndex];
        if (rootFieldItem === '' || rootFieldItem === null) {
          dispatch(arrayRemove(formName, rootField, itemIndex));
          return undefined;
        }
      }
      return value;
    } }
  >
    { children }
  </Field>
);

NestedArraySelectFieldComponent.propTypes = {
  dispatch: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  rootField: PropTypes.string.isRequired,
  formName: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  initValue: PropTypes.any,
  // eslint-disable-next-line react/forbid-prop-types
  children: PropTypes.any
};

NestedArraySelectFieldComponent.defaultProps = {
  initValue: undefined,
  children: undefined
};

const mapDispatchToProps = dispatch => ({ dispatch });

const mapStateToProps = state => ({ formName: Object.getOwnPropertyNames(state.form).filter(x => x !== 'clientselect-form')[0] });

// eslint-disable-next-line import/prefer-default-export
export const NestedArraySelectField = connect(
  mapStateToProps,
  mapDispatchToProps
)(NestedArraySelectFieldComponent);
